import { SlotGameType1_21 } from '../SlotGameType1_21';

export class WildFire2021 extends SlotGameType1_21
{
}
